
export default {
  inheritAttrs: false,
  props: {
    product: {
      type: Object,
      default: null
    },
    label: {
      type: Boolean,
      default: true
    },
    short: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    label: {
      textColor: 'grey-darkest',
      textSize: 'sm',
      display: 'block',
      marginTop: 'sm',
      marginBottom: 'xs'
    },
    price: {
      textColor: 'success',
      display: 'block'
    },
  },
  computed: {
    hasVariants() {
      return Boolean(this.product.variantsCount)
    },
    showLabel() {
      return this.short
        ? this.label && !this.product.onSale
        : this.label
    }
  }
}
